<template>
  <div class="content">
    <content-header title="はじめてのお客様へ" />
    <div class="content-body">
      B-Callオンラインサイトへご訪問いただきありがとうございます。商品についてのご質問は、お気軽にご相談･お問い合わせください。<br />
      担当スタッフが、ご予算やご希望に合ったアドバイスをいたします。<br />
      ※掲載商品は日本国内のみの販売となりますので予めご了承ください。（Products
      on this Website is not for export, only available in Japan.）
    </div>
  </div>
</template>

<script>
import ContentHeader from '@/components/modules/ContentHeader'

export default {
  components: {
    ContentHeader,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/modules/guide/Introduction.vue